import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getResistanceTypes } from '../../api/ResistanceTypeAPI';
import { AppThunk } from '../../app/store';
import { ResistanceTypeDTO } from '../../dto/ResistanceTypeDTO';

import { updateURLQuery, getQueryParam, getStringQueryArrayParam } from '../../components/QueryBuilder';
import { econdaClickEvent } from '../../Econda';
import { OptionsType, OptionType } from '../../components/filterTypes/multiselectbox/types';

interface ResistanceTypeState {
  key: string;
  filter: string;
  label: string;
  type: string;
  values: ResistanceTypeDTO[];
  isLoading: boolean;
  error: string | null;
  selected: string[];
  getOptionLabel: string;
  getOptionValue: string;
  isCombobox: boolean;
  placeholder: string;
  econdaName: string;
  infoButtonDescription: string;
}

const getOptionLabel = '';

const getOptionValue = '';

const initialState: ResistanceTypeState = {
  key: 'resistanceTypes',
  filter: '',
  label: 'filterResistanceType',
  type: 'checkbox',
  values: [],
  isLoading: false,
  error: null,
  selected: getStringQueryArrayParam('resistance', []),
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isCombobox: false,
  placeholder: '',
  econdaName: 'resistance type filter',
  infoButtonDescription: '',
};

function startLoading(state: ResistanceTypeState) {
  state.isLoading = true;
}

function loadingFailed(state: ResistanceTypeState, action: PayloadAction<string>) {
  state.isLoading = false;
  state.error = action.payload;
}

function UpdateSelectedResistanceTypes(state: ResistanceTypeState, action: PayloadAction<string>) {
  const newValues: string[] = JSON.parse(JSON.stringify(state.selected));
  const valueIndex = newValues.findIndex((option) => option === action.payload);
  if (valueIndex > -1) {
    newValues.splice(valueIndex, 1);
  } else {
    newValues.push(action.payload);
  }
  state.selected = newValues;

  econdaClickEvent('resistance categories', 'filters', 'radio button', action.payload);
  updateURLQuery('resistance', state.selected);
}

export const resistanceTypesSlice = createSlice({
  name: 'resistance type',
  initialState,
  reducers: {
    getResistanceTypesStart: startLoading,
    getResistanceTypesSuccess(state, { payload }: PayloadAction<ResistanceTypeDTO[]>) {
      state.values = state.values.concat(payload);
      state.isLoading = false;
      state.error = null;
    },
    getResistanceTypesFailure: loadingFailed,
    updateResistanceTypesSelected: UpdateSelectedResistanceTypes,
  },
});

export const {
  getResistanceTypesStart,
  getResistanceTypesSuccess,
  getResistanceTypesFailure,
  updateResistanceTypesSelected,
} = resistanceTypesSlice.actions;

export default resistanceTypesSlice.reducer;

export const fetchResistanceTypes = (query: string): AppThunk => async (dispatch) => {
  try {
    dispatch(getResistanceTypesStart());
    const resistanceTypes = await getResistanceTypes(query);
    dispatch(getResistanceTypesSuccess(resistanceTypes));
  } catch (err) {
    if (err instanceof Error) {
      dispatch(getResistanceTypesFailure(err.message));
    } else {
      dispatch(getResistanceTypesFailure("Can't dispatch getResistanceTypes"));
    }
  }
};
